<template>
    <div>
        <portal to="navbar-list">
            <navbar :site-slug="siteSlug" :menus="menus"></navbar>
        </portal>

        <div class="container">
            <div class="row mt-5" v-if="contact">
                <div class="col-12 col-md-6">
                    <div class="card shadow-sm">
                        <div class="card-header" style="background-color: rgb(250, 250, 250)">{{ $t("Contact info") }}</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-4">
                                    <h6 class="mt-1">{{ $t("Address") }}</h6>
                                </div>

                                <div class="col-8 text-secondary">
                                    <div>{{ contact.address.line_1 || $t('Not available') }}</div>
                                    <div v-if="contact.address.line_2">{{ contact.address.line_2 }}</div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-4">
                                    <h6 class="mt-1">{{ $t("Email") }}</h6>
                                </div>

                                <div class="col-8 text-secondary">
                                    {{ contact.email || $t('Not available') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 mt-4 mt-md-0">
                    <div class="card shadow-sm">
                        <div class="card-header" style="background-color: rgb(250, 250,250)">{{ $t("Opening hours") }}</div>
                        <div class="card-body">
                            <div class="row" v-for="(value, key) in contact.opening_hours" :key="key">
                                <div class="col-4">
                                    <h6 class="mt-1">{{ key | ucFirst }}</h6>
                                </div>

                                <div class="col-8 text-secondary" v-if="!value.open">{{ $t("Closed") }}</div>

                                <div class="col-8 text-secondary" v-else>
                                    {{ value.schedule }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "../../components/Navbar";

export default {
    components: { Navbar },
    data() {
        return {
            menus: [],
            siteSlug: this.$route.params.site,
            contact: null
        };
    },
    methods: {
        fetch() {
            this.$axios
                .get(`/sites/contact-info?site_slug=${this.siteSlug}`)
                .then(response => {
                    if (!response.data.item) {
                        return;
                    }

                    let days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

                    const ordered = {};

                    Object.entries(response.data.item.opening_hours).sort((a, b) => {
                        return days.indexOf(a[0]) - days.indexOf(b[0]);
                    }).forEach(function (key) {
                        ordered[key[0]] = key[1];
                    });

                    response.data.item.opening_hours = ordered;

                    this.contact = response.data.item;
                })
                .catch(() => window.location.href = "/");
        },
        fetchMenus() {
            this.$axios
                .get(`/menus?site_slug=${this.siteSlug}`)
                .then(response => {
                    this.menus = response.data.items;
                });
        }
    },
    mounted() {
        this.fetch();
        this.fetchMenus();

        this.$pageTitle = this.$t("Contact");
    }
};
</script>
